import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType, SubQuestionID } from '../types'
import {
  SlidersQuestionModelTypes,
  ISlidersQuestionModelState,
  ISlidersResponseValidation,
  SlidersSubmitResponse,
  SlidersResponse
} from './types'

const SlidersQuestionModel: IQuestionModelConstructor<SlidersQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<SlidersQuestionModelTypes, ISlidersQuestionModelState>({
    questionType: QuestionType.SLIDERS,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response, questionSchema, action }: ISlidersQuestionModelState) {
  return response.data.reduce((acc: SlidersSubmitResponse, item, i) => {
    // if (questionSchema.matrix_batches[i].hidden) {
    //   acc.push({ id: questionSchema.matrix_batches[i].answers[0].id })
    //   return acc
    // }
    if (null == item.value || false == action?.data?.rules?.show[item.id]) return acc
    acc.push({ id: questionSchema.matrix_batches[i].answers[item.value].id })
    return acc
  }, [])
}

function initState(state: ISlidersQuestionModelState): ISlidersQuestionModelState {
  state.response = {
    data: state.questionSchema.matrix_batches.map<SlidersResponse['data'][number]>(batch => {
      return { id: batch.id, value: null }
    }),
    valid: false
  }
  return state
}

function validateResponse({ response, action }: ISlidersQuestionModelState): ISlidersResponseValidation {
  if (!response.data.length)
    return {
      valid: true
    }

  const invalidBatches: SubQuestionID[] = []
  response.data.forEach(item => {
    if (null === item.value && !false !== action?.data?.rules?.show[item.id]) invalidBatches.push(item.id)
  })

  return {
    valid: !response.data.some(item => null === item.value && !item.hidden),
    invalidBatches: invalidBatches
  }
}

export default SlidersQuestionModel
